<script setup lang="ts"></script>

<template>
  <div class="overflow-hidden">
    <div class="overflow-y-scroll h-screen translate-x-8 -ml-8">
      <div class="-translate-x-8 -mr-8">
        <slot />
      </div>
    </div>
  </div>
</template>
